import { render, staticRenderFns } from "./SsoMicrosoftLoggedout.vue?vue&type=template&id=29020324&"
import script from "./SsoMicrosoftLoggedout.vue?vue&type=script&lang=js&"
export * from "./SsoMicrosoftLoggedout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports